module.exports = __webpack_public_path__ + "static/media/red-hat-safari-pinned-tab.275bd39f.svg";